<div class="signature-pad">
  <div class="signature-pad--body">
    <canvas #sPad height="100px" style="touch-action: none;"></canvas>
  </div>
</div>
<a style="float: left" (click)="clear()">Unterschrift löschen</a>
<a style="float: right" (click)="undo()"> Rückgängig</a>
